const carouselImages = [
    'akita',
    'basset-hound',
    'beagle',
    'border-collie',
    'boxer',
    'bulldog-english',
    'bullterrier-staffordshire',
    'cocker-spaniel',
    'collie',
    'dalmatian',
    'fox-terrier',
    'german-shepherd',
    'golden-retriever',
    'great-dane',
    'husky',
    'leonberger',
    'mountain-bernese',
    'pug',
    'rottweiler',
    'saint-bernard',
    'schnauzer',
    'sheepdog-english'
]

export default carouselImages